import { injectable, interfaces } from 'inversify';
import { action, IObservableArray, makeObservable, observable } from 'mobx';

export interface ICryptoStore {
  workspaceCryptos: IObservableArray<IWorkspaceCrypto>;
  get(workspaceId: string): IWorkspaceCrypto | undefined;
  set(workspaceCrypto: IWorkspaceCrypto): void;
  remove(workspaceId: string): void;
  clearAll(): void;
}

export namespace ICryptoStore {
  export const $: interfaces.ServiceIdentifier<ICryptoStore> = Symbol('CRYPTO_STORE');
}

interface IWorkspaceCrypto {
  workspaceId: string;
  checksum?: string;
  key?: CryptoKey;
  rawKey?: string;
}

@injectable()
export class CryptoStore implements ICryptoStore {
  workspaceCryptos: IObservableArray<IWorkspaceCrypto> = observable.array([]);

  constructor() {
    makeObservable(this, {
      workspaceCryptos: observable,
      get: action,
      set: action,
      remove: action,
      clearAll: action,
    });
  }

  get(workspaceId: string): IWorkspaceCrypto | undefined {
    return this.workspaceCryptos.find((x) => x.workspaceId === workspaceId);
  }

  set(workspaceCrypto: IWorkspaceCrypto): void {
    const storeIndex = this.workspaceCryptos.findIndex((x) => x.workspaceId === workspaceCrypto.workspaceId);
    if (storeIndex !== -1) {
      this.workspaceCryptos.splice(storeIndex, 1);
    }
    this.workspaceCryptos.replace([...this.workspaceCryptos, workspaceCrypto]);
  }

  remove(workspaceId: string): void {
    const storeIndex = this.workspaceCryptos.findIndex((x) => x.workspaceId === workspaceId);
    if (storeIndex !== -1) {
      this.workspaceCryptos.splice(storeIndex, 1);
      this.workspaceCryptos.replace([...this.workspaceCryptos]);
    }
  }

  clearAll(): void {
    this.workspaceCryptos.replace([]);
  }
}
